import React from 'react';
import PropTypes from 'prop-types';


const InfoTable = ({ title, rows, data }) => {
    return (
        <div className="calc-setting-table">
            <table className="table">
              <colgroup>
                <col />
                <col />
              </colgroup>
              <thead>
              <tr>
                <th colSpan="2" className="text-left calc-setting-table-header">{title}</th>
              </tr>
              </thead>
              <tbody>
              {rows.map((item, index) => 
                <tr key={index}>
                    {item.title != null && <th className="text-right" >{(typeof(item.title) === 'function' ? item.title() : item.title)}</th>}
                    <td className="text-right" colSpan={item.title == null ? "2" : "1"}>{(item.display && typeof(item.display) === 'function' ? item.display(data[item.field]) : data[item.field])}</td>
                </tr>               
              )}            
              </tbody>
            </table>
        </div>
      );
};

InfoTable.propTypes = {
    title: PropTypes.string,
    rows: PropTypes.array,
    data: PropTypes.any
};

export default InfoTable;
